import { FC } from "react";

import { useTranslation } from "react-i18next";

import { Modal, ModalSize } from "../../components";
import { LoginMethodType } from "../../interfaces";

interface ILoginMethodConfirmModal {
  visible: boolean;
  hide: () => void;
  target: LoginMethodType;
  needsPassword: boolean;
  onConfirm: () => void;
  loading: boolean;
}

export const LoginMethodConfirmModal: FC<ILoginMethodConfirmModal> = ({
  visible,
  hide,
  needsPassword,
  onConfirm,
  loading,
}) => {
  const { t } = useTranslation();

  const title = needsPassword
    ? t<string>("security.loginMethodSetPasswordFirstTitle")
    : t<string>(
        "security.loginMethodConfirmTitle",
        "Changer de méthode de connexion"
      );

  const description = needsPassword
    ? t<string>("security.loginMethodSetPasswordFirstDescription")
    : t<string>(
        "security.loginMethodConfirmDescription",
        "Vos autres appareils seront déconnectés et un e-mail de confirmation vous sera envoyé."
      );

  const confirmBtnText = needsPassword
    ? t<string>(
        "security.loginMethodSetPasswordFirstConfirm",
        "Définir un mot de passe"
      )
    : t<string>("security.loginMethodConfirm", "Confirmer");

  return (
    <Modal
      visible={visible}
      hide={hide}
      onCancel={hide}
      title={title}
      withFooter
      modalSize={ModalSize.sm}
      confirmBtnType="button"
      confirmBtnText={confirmBtnText}
      onConfirmClick={onConfirm}
      disabled={loading}
    >
      <p className="text-sm text-gray-700 mb-6 sm:mb-8">{description}</p>
    </Modal>
  );
};
